import { Component } from '@angular/core';
import { INVESTMENT_PRODUCTS } from '../../data/landing-content';

@Component({
  selector: 'landing-inversores-investment-types',
  templateUrl: './landing-investment-types.component.html',
  styleUrls: ['./landing-investment-types.component.scss'],
})
export class LandingInvestmentTypesComponent {
  readonly products = INVESTMENT_PRODUCTS;
}
